module.exports = __webpack_public_path__ + "static/media/preloader-SMALL-Doma-Earthquake.f163f7f1.gif";